import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const ndlArtifactsSlice = createCrudSlice({
  name: 'ndlArtifacts',
  idKey: 'id',
  reducers: {
    watchNdlArtifactsRequest: (state) => {
      return { ...state, fetching: true }
    },
    unwatchNdlArtifactsRequest: (state) => {
      return { ...state, fetching: false }
    },
  },
})

export const NdlArtifactsActions = ndlArtifactsSlice.actions

export const NdlArtifactsSelectors = {
  ...createCrudSelectors({ name: 'ndlArtifacts', idKey: 'id' }),
}

export default ndlArtifactsSlice.reducer
